export enum CalculatorCategoriesEnum {
  LOANS = 'loans-calculator',
  DEPOSITS = 'deposits-calculator',
}
